import { createContext } from 'react';

export const CookiegateContext = createContext({
  acceptedCookies: true,
  handleAcceptClick: () => {},
});
